import { useEffect } from "react";

import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";

import { fetchConfig } from "app/contexts";

const SENTRY_DSN =
  "https://71639aea5fcd412ab46d72c67fa23660@o553835.ingest.sentry.io/5697728";

export function handleComponentError(
  error: Error,
  info: { componentStack?: string | null },
) {
  Sentry.withScope((scope) => {
    scope.setExtra("componentStack", info.componentStack);
    Sentry.captureException(error);
  });
}

function resolveTracesSampleRate(): number {
  const rate = parseFloat(import.meta.env.VITE_SENTRY_TRACE_RATE);
  return Number.isNaN(rate) ? 0.01 : rate;
}

export async function initSentry() {
  let config;
  try {
    config = await fetchConfig();
  } catch (e) {
    console.warn("Failed to fetch config for Sentry initialization", e);
    return;
  }

  try {
    Sentry.init({
      dsn: SENTRY_DSN,
      enabled: config.sentry_enabled,
      environment: import.meta.env.MODE ?? "unknown",
      integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
      ],
      release: import.meta.env.VITE_GIT_HASH
        ? `console@${import.meta.env.VITE_GIT_HASH}`
        : undefined,
      tracesSampleRate: resolveTracesSampleRate(),
    });
  } catch (e) {
    console.warn("Sentry.init() failed; monitoring disabled", e);
  }
}
